<template>
  <v-app>
    <v-main style="background-color: #f2f7fd">
      <DefaultLayout v-if="getAuth" />
      <LoginLayout v-if="!getAuth" />
      <HomePage />
    </v-main>
  </v-app>
</template>

<script>
import DefaultLayout from "./Layout/DefaultLayout.vue";
import LoginLayout from "./Layout/LoginLayout.vue";
export default {
  name: "App",
  data() {
    return {
      getAuth: false,
    };
  },
  components: {
    DefaultLayout,
    LoginLayout,
  },
  created() {
    this.getAuthentication();
  },
  methods: {
    getAuthentication() {
      let token = localStorage.getItem("TOKEN");
      if (token) {
        this.getAuth = true;
      } else {
        console.log("working");
      }
    },
  },
};
</script>
<!-- <style>
   /* ::-webkit-scrollbar {
    width: 0px;
    height: 6px;
} */
.v-btn {
    text-transform: unset !important;
}
.body {
    background-color: #3C5AAA;
    font-family: "Inter", sans-serif;
    min-height: 100vh;
    justify-content: center;
    align-items: center;
}
::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: rgb(0, 0, 0, 0.12);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}
</style> -->
<style lang="scss">
@import "../src/scss/style.scss";
</style>
